import { useTranslation } from "react-i18next";
import HeroSection from "./components/HeroSection";
import ServicesPreview from "./components/ServicesPreview";
import WhyChooseUs from "./components/WhyChooseUs";
import TestimonialsPreview from "./components/TestimonialsPreview";
import MapSection from "./components/MapSection";
import CtaBanner from "./components/CtaBanner";

const HomePage = () => {
  useTranslation();
  return (
    <main>
      <HeroSection />
      <ServicesPreview />
      <WhyChooseUs />
      <TestimonialsPreview />
      <MapSection />
      <CtaBanner />
    </main>
  );
};

export default HomePage;
